var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CloudUploadIcon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import useTranslate from '../../../localization/helpers';
export var FileUpload = function (_a) {
    var _b;
    var onChange = _a.onChange, allowedFileSize = _a.allowedFileSize, allowedFileTypes = _a.allowedFileTypes, allowedFileTypesText = _a.allowedFileTypesText, uploadLabel = _a.uploadLabel, error = _a.error, infoText = _a.infoText;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var _c = __read(useState(), 2), file = _c[0], setFile = _c[1];
    var _d = __read(useState(''), 2), errorText = _d[0], setErrorText = _d[1];
    var _e = __read(useState(true), 2), canUpload = _e[0], setCanUpload = _e[1];
    useEffect(function () {
        if (error)
            setErrorText(error);
    }, [error]);
    var fileTypeError = function () {
        setErrorText(translate('fileUpload.fileTypeError', {
            field: allowedFileTypesText
        }));
        setCanUpload(true);
    };
    var fileSizeError = function () {
        setErrorText(translate('fileUpload.fileSizeError', {
            count: allowedFileSize
        }));
        setCanUpload(true);
    };
    var handleFileChange = function (file) {
        setErrorText('');
        var selectedFile;
        if (file instanceof FileList) {
            selectedFile = file[0];
        }
        else if (Array.isArray(file)) {
            selectedFile = file[0];
        }
        else {
            selectedFile = file;
        }
        setFile(selectedFile);
        onChange(selectedFile);
    };
    return (_jsxs(Grid, { size: { xs: 12 }, children: [_jsx(Box, { sx: {
                    backgroundColor: theme.palette.common.white,
                    flexDirection: { xs: 'column', md: 'row' }
                }, children: _jsx(FileUploader, { handleChange: handleFileChange, types: allowedFileTypes, disabled: !canUpload, required: true, maxSize: allowedFileSize, onTypeError: fileTypeError, onSizeError: fileSizeError, children: _jsx(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRadius: '12px', sx: {
                            cursor: 'pointer',
                            backgroundColor: '#919EAB33',
                            height: '100%',
                            width: '100%',
                            border: '1px dashed rgba(145, 158, 171, 0.20)'
                        }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 4, children: _jsxs("label", { htmlFor: 'fileInput', style: { display: 'contents', cursor: 'pointer' }, children: [_jsx(CloudUploadIcon, {}), _jsx(Typography, { variant: 'body2', color: '#919EAB', style: { wordBreak: 'break-all' }, children: (_b = file === null || file === void 0 ? void 0 : file.name) !== null && _b !== void 0 ? _b : uploadLabel })] }) }) }) }) }), infoText && (_jsx(FormHelperText, { sx: { display: 'flex', justifyContent: 'center', textAlign: 'center' }, children: infoText })), errorText && (_jsx(FormHelperText, { sx: { display: 'flex', justifyContent: 'center', textAlign: 'center' }, error: true, children: errorText }))] }));
};
export default FileUpload;
